package com.veldekar.model

data class VeldekarDate(
    val season: String,
    val day: Int
) {
    override fun toString(): String = "$season $day"
}

data class Bookmark(
    val icon: String? = null,
    val title: String,
    val startDate: VeldekarDate,
    val endDate: VeldekarDate? = null,
    val targetAnchor: String
) {
    val isSpan: Boolean get() = endDate != null && (endDate.season != startDate.season || endDate.day != startDate.day)
}

data class BookmarkCategory(
    val icon: String,
    val title: String,
    val bookmarks: List<Bookmark>
)
